var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createElement as _createElement } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { FloatingItem } from "../floatingItem";
import { CamsIcon } from "../../@assets/projects/CAMS";
import { FtsIcon } from "../../@assets/projects/FTS";
import { EdmsIcon } from "../../@assets/projects/EDMS";
import { FcssIcon } from "../../@assets/projects/FCSS";
import { FmsIcon } from "../../@assets/projects/FMS";
import { GomsIcon } from "../../@assets/projects/GOMS";
import { HomeIcon } from "../../@assets/projects/home";
import { ImsIcon } from "../../@assets/projects/IMS";
import { InvIcon } from "../../@assets/projects/INV";
import { MdmIcon } from "../../@assets/projects/MDM";
import { TmsIcon } from "../../@assets/projects/TMS";
import "../../@assets/styles/app.css";
var FloatingList = memo(function (props) {
    var open = props.open, projectName = props.projectName, onClose = props.onClose, checkPermission = props.checkPermission;
    var ref = useRef(null);
    var _a = useState("fadeInDown"), animation = _a[0], setAnimation = _a[1];
    var _b = useState(), backdropClass = _b[0], setBackdropClass = _b[1];
    var items = useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return [
            {
                icon: _jsx(HomeIcon, {}),
                name: "Dashboard",
                color: "#1F56A3",
                link: ((_a = window._env_) === null || _a === void 0 ? void 0 : _a.WEB_DASHBOARD) || "",
                show: true,
            },
            {
                projectName: "WEB_FTS",
                icon: _jsx(FtsIcon, {}),
                name: "FTS",
                color: "#40B5CF",
                link: "".concat((_b = window._env_) === null || _b === void 0 ? void 0 : _b.WEB_FTS, "/panel/FTS"),
                show: checkPermission(["PANEL:FLIGHT_GANTT_SYSTEM"]),
            },
            {
                projectName: "WEB_EDMS",
                icon: _jsx(EdmsIcon, {}),
                name: "EDMS",
                color: "#CE6605",
                link: "".concat((_c = window._env_) === null || _c === void 0 ? void 0 : _c.WEB_EDMS, "/panel/folder/list"),
                show: checkPermission(["PANEL:ELECTRONIC_DOCUMENT_MANAGEMENT_SYSTEM"]),
            },
            {
                projectName: "WEB_GOMS",
                icon: _jsx(GomsIcon, {}),
                name: "GOMS",
                color: "#028888",
                link: "".concat((_d = window._env_) === null || _d === void 0 ? void 0 : _d.WEB_GOMS, "/panel/catering/list"),
                show: checkPermission(["PANEL:TURNAROUND_MANAGEMENT_SYSTEM"]),
            },
            {
                projectName: "WEB_FCSS",
                icon: _jsx(FcssIcon, {}),
                name: "FCSS",
                color: "#8621A9",
                link: "".concat((_e = window._env_) === null || _e === void 0 ? void 0 : _e.WEB_FCSS, "/panel/cockpits"),
                show: checkPermission(["PANEL:FLIGHT_CREW_SCHEDULING_SYSTEM"]),
            },
            {
                projectName: "WEB_CAMS",
                icon: _jsx(CamsIcon, {}),
                name: "CAMS",
                color: "#A82B56",
                link: "".concat((_f = window._env_) === null || _f === void 0 ? void 0 : _f.WEB_CAMS, "/panel/ATL"),
                show: checkPermission([
                    "PANEL:CONTINUOES_AIRWORTHINESS_MONITORING_SYSTEM",
                ]),
            },
            {
                projectName: "WEB_INV",
                icon: _jsx(InvIcon, {}),
                name: "INV",
                color: "#6195D9",
                link: "".concat((_g = window._env_) === null || _g === void 0 ? void 0 : _g.WEB_INV, "/panel/store"),
                show: checkPermission(["PANEL:INVENTORY_MANAGMENT_SYSTEM"]),
            },
            {
                projectName: "WEB_IMS",
                icon: _jsx(ImsIcon, {}),
                name: "IMS",
                color: "#D69A25",
                link: "".concat((_h = window._env_) === null || _h === void 0 ? void 0 : _h.WEB_IMS, "/panel/invoiceList"),
                show: checkPermission(["PANEL:INVOICE_MANAGEMENT_SYSTEM"]),
            },
            {
                projectName: "WEB_TMS",
                icon: _jsx(TmsIcon, {}),
                name: "TMS",
                color: "#08ADF3",
                link: "".concat((_j = window._env_) === null || _j === void 0 ? void 0 : _j.WEB_TMS, "/panel/users"),
                show: checkPermission(["PANEL:TMS_USERS_VIEW_USERS_LIST"]),
            },
            {
                projectName: "WEB_TAMS",
                icon: _jsx(GomsIcon, {}),
                name: "TAMS",
                color: "#7FB1C0",
                link: "".concat((_k = window._env_) === null || _k === void 0 ? void 0 : _k.WEB_TAMS, "/turnarounds/list"),
                show: checkPermission(["PANEL:TURNAROUND_MANAGEMENT_SYSTEM"]),
            },
            {
                projectName: "WEB_FMS",
                icon: _jsx(FmsIcon, {}),
                name: "FMS",
                color: "#7870DF",
                link: "".concat((_l = window._env_) === null || _l === void 0 ? void 0 : _l.WEB_FMS, "/flights/published-flight-list"),
                show: checkPermission(["PANEL:FLIGHT_MANAGEMENT_SYSTERM"]),
            },
            {
                projectName: "WEB_MDM",
                icon: _jsx(MdmIcon, {}),
                name: "MDM",
                color: "#17985A",
                link: "".concat((_m = window._env_) === null || _m === void 0 ? void 0 : _m.WEB_MDM, "/panel/users-list"),
                show: checkPermission(["PANEL:MASTER_DATA_MANAGEMENT"]),
            },
        ];
    }, [checkPermission]);
    var handleLink = function (link) {
        handleClickAway();
        window.location.replace(link);
    };
    var handleClickAway = useCallback(function () {
        setAnimation("fadeOutUp");
        setBackdropClass("");
    }, []);
    var handleAnimation = useCallback(function (animationName) {
        if (animationName === "fadeOutUp")
            onClose();
    }, [onClose]);
    useEffect(function () {
        setAnimation("fadeInDown");
        setBackdropClass("floating-backdrop");
    }, [open]);
    return (_jsx("div", __assign({ ref: ref, className: "floating-root ".concat(backdropClass), onClick: handleClickAway }, { children: _jsx("ul", __assign({ className: "floating-container" }, { children: items
                .filter(function (I) { return I.projectName !== projectName; })
                .map(function (item, index) { return (_createElement(FloatingItem, __assign({}, item, { key: index, className: "floating-item animate__".concat(animation, " animate__animated"), onAnimationEnd: function (e) { return handleAnimation(e.animationName); }, onClick: function () { return handleLink(item.link); } }))); }) })) })));
});
export { FloatingList };
export default FloatingList;
